import React from 'react';
import MotorCurrencySelect from './MotorCurrencySelect';

const JaluziSettings = React.memo(({
  activeTypeTab,
  jaluziExtras,
  setJaluziExtras,
  metalJaluziExtras,
  setMetalJaluziExtras
}) => {
  const isAhsap = activeTypeTab === 'ahsapJaluzi';
  const extras = isAhsap ? jaluziExtras : metalJaluziExtras;
  const setExtras = isAhsap ? setJaluziExtras : setMetalJaluziExtras;

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları</h4>
        </div>
        <div className="settings-grid settings-grid-motor">
          <MotorCurrencySelect
            value={extras.motorCurrency}
            onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}
          />
          <div className="form-group">
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-title">
          <i className={isAhsap ? 'fas fa-sliders-h' : 'fas fa-layer-group'}></i>
          <h4>{isAhsap ? 'Ahşap' : 'Metal'} Jaluzi Ek Ücretler (₺)</h4>
        </div>
        <div className="settings-grid">
          <div className="form-group">
            <label>{isAhsap ? 'Zıgıl Sistem' : 'Zıgıl Sistem (Adet)'}</label>
            <input type="number" value={extras.zigil} onChange={(e) => setExtras(p => ({ ...p, zigil: e.target.value }))} />
          </div>
          {!isAhsap && (
            <>
              <div className="form-group">
                <label>Redüktörlü Farkı (m2)</label>
                <input type="number" value={extras.reduktor} onChange={(e) => setExtras(p => ({ ...p, reduktor: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>İki Cam Arası (Adet)</label>
                <input type="number" value={extras.ikiCamArasi} onChange={(e) => setExtras(p => ({ ...p, ikiCamArasi: e.target.value }))} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
});

export default JaluziSettings;
